var Constants = /** @class */ (function () {
    function Constants() {
    }
    Constants.CONFIRM_CLIENT_APP_IDS = ['SurveyBuilderWeb', 'QuestionLibraryWeb', 'HierarchyManagerWeb'];
    // ROUTES
    Constants.ROUTE_CONFIRM_CLIENT = '/confirm-client?ReturnUrl={ReturnUrl}';
    // LOCAL STORAGE KEY
    Constants.LOCAL_STORAGE_CLIENT_CONFIRMED = 'ClientConfirmed';
    return Constants;
}());
export default Constants;
